<template>
  <admin-layout :sectionTitle="sectionTitle">
   <!-- <div class="page-header">
      <div class="row align-items-end">
        <div class="col-sm mb-2 mb-sm-0">
          <h1 class="page-header-title">{{ municipality.name }}</h1>
        </div>

        <div class="col-sm-auto">
          <button type="button" @click="onSubmit" :class="{ 'opacity-25': form.processing }" :disabled="form.processing" class="btn btn-primary">Salva</button>
        </div>
      </div>
    </div>-->

    <div class="card mb-4">
      <div class="card-body">
        <div class="d-flex w-100 justify-content-between align-items-center">
          <h3 class="mb-0">Status</h3>

          <label class="toggle-switch mx-2" :for="`customSwitch-${municipality.id}`">
            <input type="checkbox" @change="updateStatus" class="js-toggle-switch toggle-switch-input" :id="`customSwitch-${municipality.id}`" :checked="municipality.active" />
            <span class="toggle-switch-label">
              <span class="toggle-switch-indicator"></span>
            </span>
          </label>
        </div>
      </div>
    </div>

    <div class="card admin-municipalities-show">
      <div class="card-header">
        <div class="row justify-content-between align-items-center flex-grow-1">
          <div class="col-sm-6 col-md-4">
            <h3 class="mb-0">Ultimi immobili caricati</h3>
          </div>
        </div>
      </div>

      <div class="table-responsive datatable-custom">
        <table id="datatable" class="table table-lg table-borderless table-thead-bordered table-nowrap table-align-middle card-table">
          <thead class="thead-light">
            <tr>
              <th>Codice</th>
              <th>Indirizzo</th>
              <th>Numero</th>
              <th>Comune</th>
              <th>Provenienza</th>
              <th>Status</th>
              <th></th>
            </tr>
          </thead>

          <tbody>
            <tr v-if="propertyIndex <= propertiesToShow" v-for="propertyIndex in propertiesToShow">
              <td>
                <strong>#{{ propertiies[propertyIndex - 1].id }}</strong>
              </td>
              <td>
                <strong>{{ propertiies[propertyIndex - 1].address }} {{ propertiies[propertyIndex - 1].house_number }}, {{ propertiies[propertyIndex - 1].postal_code }}</strong>
              </td>
              <td>{{ propertiies[propertyIndex - 1].house_number }}</td>
              <td>{{ propertiies[propertyIndex - 1].municipality }}</td>
              <td v-text="getPropertyProvenance(propertiies[propertyIndex - 1])"></td>
              <td>
                <div class="dropdown">
                  <button class="badge-status badge-called dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Chiamato</button>
                  <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                    <a class="badge-status badge-called dropdown-item" href="#">Chiamato</a>
                    <a class="badge-status badge-inspection dropdown-item" href="#">Sopralluogo</a>
                    <a class="badge-status badge-waiting dropdown-item" href="#">Prev. in attesa di doc</a>
                    <a class="badge-status badge-processing dropdown-item" href="#">Prev. in lavorazione</a>
                  </div>
                </div>
              </td>
              <td class="actions">
                <a class="btn btn-sm p-0 btn-link" :href="route('properties.show', propertiies[propertyIndex - 1].id)">
                  <i class="tio-visible-outlined"></i>
                </a>
                <a class="btn btn-sm p-0 btn-link" @click="setToDeleteProperty(propertiies[propertyIndex - 1].id)" data-toggle="modal" data-target="#properties-delete">
                  <i class="tio-delete"></i>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="card-footer text-center border-0">
        <a @click="showProperties" v-if="this.properties.length > 5" type="button" class="btn btn-link underline">Visualizza altri</a>
      </div>
    </div>

    <div class="algorithm-container">
      <delete-property @delete-property="deleteProperty" :property_id="to_delete_property_id"></delete-property>
    </div>
  </admin-layout>
</template>

<script>
import AdminLayout from "@/Layouts/AdminLayout";
import DeleteProperty from "@/Pages/Admin/Properties/Delete";

export default {
  components: {
    AdminLayout,
    DeleteProperty,
  },

  props: ["properties", "sectionTitle"],

  data() {
    return {
      errors: {},
      pagination: {},
      municipality: this.$page.props.municipality,
      form: this.$inertia.form({
        name: this.$page.props.municipality.name,
        active: this.$page.props.municipality.active,
        /*settings: this.$page.props.settings,*/
        /*types: this.$page.props.types,*/
      }),
      to_delete_property_id: null,
      propertiies: this.properties,
      propertiesToShow: this.properties.length >= 5 ? 5 : this.properties.length,
      /*semaforos: [
        { index: 1, label: "Verde", value: "bg-success" },
        { index: 1, label: "Giallo", value: "bg-warning" },
        { index: 1, label: "Rosso", value: "bg-danger" },
      ],*/
      filters: [],
      display_filters: false,
    };
  },

  methods: {
    showProperties() {
      if (this.propertiesToShow + 5 > this.propertiies.length) {
        var difference = this.propertiesToShow + 5 - this.propertiies.length;

        this.propertiesToShow += 5 - difference;

        return;
      }

      this.propertiesToShow += 5;
    },

    updateStatus(e) {
      this.form.active = e.target.checked;
    },

    onAddAlgorithm(type) {
      this.form.types.push(type);
    },

    onRemoveAlgorithm(type) {
      this.form.types = this.form.types.filter((i) => i != type);
    },

    onSubmit() {
      this.form.put(route("municipalities.update", this.municipality.id), {
        onSuccess: () => {},
        onError: () => {},
      });
    },

    getPropertyProvenance(property) {
      let provenance = "Privato";
      if (property.inserted_by === "agency") provenance = "Agenzia";

      return provenance;
    },

    setToDeleteProperty(id) {
      this.to_delete_property_id = id;
    },

    deleteProperty(id) {
      axios.delete(route("properties.destroy", id)).catch((error) => {
        console.log(error);
      });

      const index = this.propertiies.findIndex((property) => property.id === id);

      if (~index) this.propertiies.splice(index, 1);

      this.propertiesToShow -= 1;

      $("#properties-delete").modal("hide");

      this.$toast.success("Immobile eliminato con successo");
    },

    onChange(event, type) {
      if (event.target.value === "all") {
        const index = this.filters.findIndex((filter) => filter.type === type);

        if (~index) this.filters.splice(index, 1);

        this.propertiies = this.properties;
        this.propertiesToShow = this.propertiies.length;
      } else {
        const index = this.filters.findIndex((filter) => filter.type === type);

        if (!~index) {
          this.filters.push({
            type: type,
            value: event.target.value,
          });
        } else {
          let selected_filter = this.filters.filter((filter) => filter.type === type);

          selected_filter[0].value = event.target.value;
        }


        this.propertiesToShow = this.propertiies.length;
      }
    },

    toggleFilters() {
      this.display_filters === true ? (this.display_filters = false) : (this.display_filters = true);
    },

    hideFilters() {
      this.display_filters = false;
    },
  },
};
</script>
